// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-request-order {
    box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
    margin-bottom: 10px;
}
.submit-request-container {
    display: contents;
}
.btn-submit-request-order {
    margin-bottom: 20px;
    margin-top: 20px;
}`, "",{"version":3,"sources":["webpack://./src/pages/Order/Order.css"],"names":[],"mappings":"AAAA;IACI,iDAAiD;IACjD,mBAAmB;AACvB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,mBAAmB;IACnB,gBAAgB;AACpB","sourcesContent":[".form-request-order {\n    box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;\n    margin-bottom: 10px;\n}\n.submit-request-container {\n    display: contents;\n}\n.btn-submit-request-order {\n    margin-bottom: 20px;\n    margin-top: 20px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
